import { services, store } from '@/core/redux/index';

export const resetAPIState = () =>
  services.forEach((service) => store.dispatch(service.util.resetApiState()));
